import styled from "styled-components";

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
  min-height: 100vh;
  padding-top: 120px;

  .boxButton {
    display: flex;
    justify-content: right;
    margin: 30px;
  }

  .footerPosition {
    position: relative;
    width: 100%;
    height: 100px;
    left: 0;
    bottom: 0;
  }
  @media (min-width: 768px) {
    padding-top: 150px;
  }
`;

export const SearchBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  margin-right: 30px;

  input {
    font-size: 18px;
    padding: 10px 20px 10px 5px;
    margin-right: 20px;
    width: 80%;
    border: none;
    border-bottom: 1px solid var(--black-default);
  }

  @media (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: center;
    margin: 0;
    button {
      margin-top: 20px;
    }
  }
`;

export const GuestList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 16px 50px 0;
  min-width: 100%;
  min-height: 70%;
`;
